export class ServiceGroupCategoryQueryParameters {
  description?: string;
  gmStandard?: string;
  id?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string[];

  constructor(obj?: ServiceGroupCategoryQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
